/**
 * Etichette e toni dei livelli di prezzo di un'analisi (F-068), separati da
 * `PriceLadder.tsx` per la stessa ragione di `analysis-rating.ts`: un file che
 * esporta sia componenti sia costanti rompe il Fast Refresh di Vite.
 */

import type { PriceLevelKind } from './ai-analysis-api';

export const LEVEL_LABELS: Record<PriceLevelKind, string> = {
  stop_loss: 'Stop loss',
  support: 'Supporto',
  entry: 'Ingresso',
  current: 'Prezzo attuale',
  target: 'Obiettivo',
  resistance: 'Resistenza',
  take_profit: 'Presa di profitto',
};

/** Il colore dice a che cosa serve il livello: difesa, riferimento, destinazione. */
export const LEVEL_TONE: Record<PriceLevelKind, 'danger' | 'neutral' | 'accent' | 'positive'> = {
  stop_loss: 'danger',
  support: 'danger',
  entry: 'accent',
  current: 'neutral',
  target: 'positive',
  resistance: 'positive',
  take_profit: 'positive',
};
